/* ==========================================================================
   Kylea - Layout Winter Sale
   Scaglioni quantità, countdown, carousel, video, modali, regalo automatico
   (calzini e borsa, paia contate su tutti i modelli insieme).
   Nessuna dipendenza esterna. Usa gli eventi nativi del tema (variant:added,
   cart:updated, cart:refresh) come il resto del tema.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__kyMainLoaded) return;
  window.__kyMainLoaded = true;

  var SYNC_HEADER = 'X-Ky-Sync';

  /* ---------- Utility ---------- */
  function formatMoney(cents) {
    var format = (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.moneyFormat) || '{{amount_with_comma_separator}}€';
    cents = Math.round(Number(cents) || 0);
    function withDelimiters(number, precision, thousands, decimal) {
      var n = (number / 100).toFixed(precision);
      var parts = n.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return parts[1] ? dollars + decimal + parts[1] : dollars;
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount': return withDelimiters(cents, 2, ',', '.');
        case 'amount_no_decimals': return withDelimiters(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelimiters(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelimiters(cents, 0, '.', ',');
        default: return withDelimiters(cents, 2, '.', ',');
      }
    });
  }
  function moneyShort(cents) {
    return formatMoney(cents).replace(/[,.]00(?=\D*$)/, '');
  }
  function emit(name, detail, target) {
    (target || document.documentElement).dispatchEvent(new CustomEvent(name, { bubbles: true, cancelable: true, detail: detail || {} }));
  }
  function jsonFetch(url, options) {
    options = options || {};
    options.headers = Object.assign({ 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, options.headers || {});
    return fetch(url, options).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) { var e = new Error(data && (data.description || data.message) || 'Errore'); e.data = data; throw e; }
        return data;
      });
    });
  }
  function refreshCart(openDrawer) {
    return jsonFetch('/cart.js', { method: 'GET', headers: { [SYNC_HEADER]: '1' } })
      .then(function (cart) {
        return fetch(window.location.pathname + '?sections=mini-cart', { headers: { [SYNC_HEADER]: '1' } })
          .then(function (r) { return r.ok ? r.json() : {}; })
          .catch(function () { return {}; })
          .then(function (sections) {
            var detail = Object.assign({}, cart, { sections: sections });
            emit('cart:updated', { cart: detail });
            emit('cart:refresh', { cart: detail, openMiniCart: !!openDrawer });
            return cart;
          });
      });
  }

  /* ---------- Countdown ---------- */
  function endOfDay() {
    var d = new Date();
    d.setHours(23, 59, 59, 999);
    return d.getTime();
  }
  function parseEnd(value) {
    if (!value) return null;
    var t = Date.parse(String(value).trim().replace(' ', 'T'));
    return isNaN(t) ? null : t;
  }
  // Countdown per visitatore: X ore dalla prima visita, salvato nel browser per campagna.
  // Se il cliente torna riprende da dove era; quando scade riparte alla visita successiva.
  var visitorEndValue = null;
  function visitorEnd() {
    if (visitorEndValue) return visitorEndValue;
    var cfg = window.KyleaTimer || {};
    var hours = Number(cfg.hours) || 10;
    var key = 'ky_timer_' + (cfg.key || 'campagna');
    var saved = null;
    try { saved = parseInt(localStorage.getItem(key), 10); } catch (e) {}
    if (saved && saved > Date.now()) {
      visitorEndValue = saved;
    } else {
      visitorEndValue = Date.now() + hours * 3600000;
      try { localStorage.setItem(key, String(visitorEndValue)); } catch (e) {}
    }
    return visitorEndValue;
  }
  if (!customElements.get('ky-countdown')) {
    customElements.define('ky-countdown', class extends HTMLElement {
      connectedCallback() {
        this.mode = this.dataset.mode || 'midnight';
        this.format = this.dataset.format || 'inline';
        this.tick = this.tick.bind(this);
        this.tick();
        this.timer = setInterval(this.tick, 1000);
      }
      disconnectedCallback() { clearInterval(this.timer); }
      target() {
        if (this.mode === 'fixed') return parseEnd(this.dataset.end);
        if (this.mode === 'visitor') return visitorEnd();
        return endOfDay();
      }
      tick() {
        var end = this.target();
        var diff = end ? end - Date.now() : 0;
        if (!end || diff <= 0) {
          clearInterval(this.timer);
          if (this.dataset.expired) this.textContent = this.dataset.expired;
          this.closest('[data-ky-hide-expired]') && (this.closest('[data-ky-hide-expired]').hidden = true);
          return;
        }
        var s = Math.floor(diff / 1000);
        var days = Math.floor(s / 86400); s -= days * 86400;
        var hrs = Math.floor(s / 3600); s -= hrs * 3600;
        var mins = Math.floor(s / 60); var secs = s - mins * 60;
        var pad = function (n) { return String(n).padStart(2, '0'); };
        if (this.format === 'blocks') {
          var labels = (this.dataset.labels || 'GG,ORE,MIN,SEC').split(',');
          var units = [[days, labels[0]], [hrs, labels[1]], [mins, labels[2]], [secs, labels[3]]];
          if (!days) units.shift();
          this.innerHTML = units.map(function (u) {
            return '<span class="ky-cd__unit"><span class="ky-cd__num">' + pad(u[0]) + '</span><span class="ky-cd__lbl">' + u[1] + '</span></span>';
          }).join('<span class="ky-cd__sep">:</span>');
        } else {
          this.textContent = (days ? days + 'g ' : '') + pad(hrs) + ':' + pad(mins) + ':' + pad(secs);
        }
      }
    });
  }

  /* ---------- Scaglioni ---------- */
  function initTiers(root) {
    if (root.__kyInit) return;
    root.__kyInit = true;

    var variants = [];
    try { variants = JSON.parse(root.querySelector('[data-ky-variants]').textContent); } catch (e) {}
    var swatchColors = {};
    try { swatchColors = JSON.parse(root.querySelector('[data-ky-swatch-colors]').textContent); } catch (e) {}

    var colorPos = parseInt(root.dataset.colorPos, 10) || 0;
    var sizePos = parseInt(root.dataset.sizePos, 10) || 0;
    var requireSize = root.dataset.requireSize === 'true';
    var sizePlaceholder = root.dataset.sizePlaceholder || 'Taglia';
    var tiers = Array.prototype.slice.call(root.querySelectorAll('[data-ky-tier]'));
    var atc = root.querySelector('[data-ky-atc]');
    var errorEl = root.querySelector('[data-ky-error]');
    var section = root.closest('.shopify-section') || document;

    function opt(v, pos) { return pos ? v['o' + pos] : null; }
    function unique(arr) { return arr.filter(function (x, i) { return x != null && arr.indexOf(x) === i; }); }
    var colors = unique(variants.map(function (v) { return opt(v, colorPos); }));
    var sizes = unique(variants.map(function (v) { return opt(v, sizePos); }));

    function findVariant(color, size) {
      return variants.find(function (v) {
        return (!colorPos || v['o' + colorPos] === color) && (!sizePos || v['o' + sizePos] === size);
      });
    }
    function firstAvailableSize(color) {
      var v = variants.find(function (x) { return (!colorPos || x['o' + colorPos] === color) && x.available; });
      return v ? opt(v, sizePos) : sizes[0];
    }

    var activeSwatch = root.querySelector('.ky-swatch.is-active');
    var defaultColor = activeSwatch ? activeSwatch.dataset.kySwatch : colors[0];
    var upsellQtys = Array.prototype.map.call(root.querySelectorAll('[data-ky-upsell]'), function (u) { return Number(u.dataset.qty) || 1; });
    var maxQty = Math.max.apply(null, tiers.map(function (t) { return Number(t.dataset.qty) || 1; }).concat(upsellQtys, [1]));
    var rows = [];
    for (var i = 0; i < maxQty; i++) {
      rows.push({ color: defaultColor, size: requireSize ? null : firstAvailableSize(defaultColor) });
    }

    function selectedTier() {
      return tiers.find(function (t) { return t.classList.contains('is-selected'); }) || tiers[0];
    }

    // Paio in piu': se la casella dello scaglione scelto e'
    // spuntata si compra un paio in piu', con la sua riga colore/taglia.
    function upsellOf(t) { return t ? t.querySelector('[data-ky-upsell]') : null; }
    function upsellOn(t) {
      var u = upsellOf(t);
      var c = u && u.querySelector('[data-ky-upsell-check]');
      return !!(c && c.checked);
    }
    function buyQty(t) {
      return upsellOn(t) ? Number(upsellOf(t).dataset.qty) : (Number(t.dataset.qty) || 1);
    }

    function dotStyle(color) {
      var hex = swatchColors[String(color || '').toLowerCase()];
      return hex ? 'background:' + hex : 'background:#ddd';
    }

    // Prodotto in aggiunta (es. fodera coordinata): casella sotto gli scaglioni.
    // Il colore segue quello della prima riga finche' il cliente non lo cambia.
    var addon = root.querySelector('[data-ky-addon]');
    var addonCheck = addon ? addon.querySelector('[data-ky-addon-check]') : null;
    var addonSelect = addon ? addon.querySelector('[data-ky-addon-variant]') : null;
    var addonTouched = false;
    function addonOn() { return !!(addonCheck && addonCheck.checked); }
    function addonOption() { return addonSelect ? addonSelect.options[addonSelect.selectedIndex] : null; }
    function addonVariantId() {
      var o = addonOption();
      return Number(o ? o.value : addon.dataset.variant);
    }
    function addonPrice() {
      var o = addonOption();
      var price = Number(o ? o.dataset.price : addon.dataset.price) || 0;
      var compare = Number(o ? o.dataset.compare : addon.dataset.compare) || price;
      var sale = Math.max(0, price - (Number(addon.dataset.discount) || 0));
      return { full: Math.max(compare, price), price: sale };
    }
    function syncAddonColor() {
      if (!addonSelect || addonTouched || !rows[0]) return;
      var want = String(rows[0].color || '').toLowerCase();
      var opts = Array.prototype.filter.call(addonSelect.options, function (o) { return !o.disabled; });
      var match = opts.find(function (o) { return String(o.dataset.name || '').toLowerCase() === want; }) || opts[0];
      if (match) addonSelect.value = match.value;
    }
    function renderAddon() {
      if (!addon) return;
      addon.classList.toggle('is-checked', addonOn());
      var p = addonPrice();
      var pe = addon.querySelector('[data-ky-addon-price]');
      var ce = addon.querySelector('[data-ky-addon-compare]');
      if (pe) pe.textContent = formatMoney(p.price);
      if (ce) ce.textContent = formatMoney(p.full);
      var dot = addon.querySelector('[data-ky-addon-dot]');
      var o = addonOption();
      if (dot && o) dot.setAttribute('style', dotStyle(o.dataset.name));
    }

    function buildRow(index) {
      var row = rows[index];
      var wrap = document.createElement('div');
      wrap.className = 'ky-pair';
      var html = '';
      if (colorPos) {
        html += '<label class="ky-select ky-select--color"><span class="ky-select__dot" style="' + dotStyle(row.color) + '"></span><select data-ky-row="' + index + '" data-ky-field="color" aria-label="Colore paio ' + (index + 1) + '">';
        colors.forEach(function (c) {
          var any = variants.some(function (v) { return v['o' + colorPos] === c && v.available; });
          html += '<option value="' + c.replace(/"/g, '&quot;') + '"' + (c === row.color ? ' selected' : '') + (any ? '' : ' disabled') + '>' + c + '</option>';
        });
        html += '</select></label>';
      }
      if (sizePos) {
        html += '<label class="ky-select ky-select--size"><select data-ky-row="' + index + '" data-ky-field="size" aria-label="Taglia paio ' + (index + 1) + '">';
        if (requireSize) html += '<option value=""' + (row.size ? '' : ' selected') + ' disabled>' + sizePlaceholder + '</option>';
        sizes.forEach(function (s) {
          var v = findVariant(row.color, s);
          var ok = v && v.available;
          html += '<option value="' + s.replace(/"/g, '&quot;') + '"' + (s === row.size ? ' selected' : '') + (ok ? '' : ' disabled') + '>' + s + (ok ? '' : ' - esaurita') + '</option>';
        });
        html += '</select></label>';
      }
      wrap.innerHTML = html;
      return wrap;
    }

    function renderPairs() {
      tiers.forEach(function (t) {
        var box = t.querySelector('[data-ky-pairs]');
        var upBox = t.querySelector('[data-ky-upsell-pair]');
        if (upBox) upBox.innerHTML = '';
        if (!box) return;
        box.innerHTML = '';
        if (!t.classList.contains('is-selected')) return;
        var qty = Number(t.dataset.qty) || 1;
        for (var i = 0; i < qty; i++) box.appendChild(buildRow(i));
        if (upBox) upBox.appendChild(buildRow(Number(upsellOf(t).dataset.qty) - 1));
      });
    }

    var compareFull = root.dataset.compareFull === 'true';
    var giftUnit = Number(root.dataset.giftUnit) || 0;
    var giftPerPair = root.dataset.giftPerPair !== 'false';
    var giftFixed = Number(root.dataset.giftFixed) || 1;
    var bagOn = root.dataset.bagOn === 'true';
    var bagValue = Number(root.dataset.bagValue) || 0;
    var bagMin = Number(root.dataset.bagMin) || 0;
    function rowCompare(i) {
      var r = rows[i];
      var v = findVariant(r.color, r.size || firstAvailableSize(r.color)) || variants[0];
      return v ? Math.max(Number(v.price) || 0, Number(v.compare) || 0) : 0;
    }
    function fullValue(t, q) {
      var sum = 0;
      for (var i = 0; i < q; i++) sum += rowCompare(i);
      if (t.dataset.gift === 'true') {
        sum += giftUnit * (giftPerPair ? q : giftFixed);
        if (bagOn && bagMin > 0 && q >= bagMin) sum += bagValue;
      }
      return sum;
    }

    function rowPrice(i) {
      var r = rows[i];
      var v = findVariant(r.color, r.size || firstAvailableSize(r.color));
      return v ? v.price : (variants[0] ? variants[0].price : 0);
    }

    // Quattro tipi di offerta, gli stessi calcolati in ky-tiers.liquid.
    // Qui pero' i prezzi delle righe possono essere diversi tra loro
    // (colori/taglie con prezzo diverso), quindi si ragiona sull'elenco.
    function tierOffer(t, prices) {
      var qty = prices.length;
      var full = 0;
      for (var i = 0; i < qty; i++) full += prices[i];
      var type = t.dataset.offerType || 'unit';
      var value = parseFloat(String(t.dataset.offerValue || '0').replace(',', '.'));
      if (!isFinite(value)) value = 0;
      var saving = 0;
      var freeQty = 0;
      if (type === 'percent') {
        if (value > 0) saving = Math.round(full * value / 100);
      } else if (type === 'total') {
        var fixed = Math.round(value * 100);
        if (fixed > 0 && fixed < full) saving = full - fixed;
      } else if (type === 'bxgy') {
        var paid = Math.round(value);
        if (paid > 0 && paid < qty) {
          freeQty = qty - paid;
          // si regalano le righe meno care: e' la direzione prudente,
          // il prezzo mostrato non finisce mai sotto quello reale.
          var asc = prices.slice().sort(function (a, b) { return a - b; });
          for (var j = 0; j < freeQty; j++) saving += asc[j];
        }
      } else if (value > 0) {
        saving = Math.round(value * 100 * qty);
      }
      if (saving < 0) saving = 0;
      if (saving > full) saving = full;
      return { full: full, saving: saving, freeQty: freeQty };
    }

    function updatePrices() {
      syncAddonColor();
      renderAddon();
      tiers.forEach(function (t) {
        var qty = Number(t.dataset.qty) || 1;
        var prices = [];
        for (var i = 0; i < qty; i++) prices.push(rowPrice(i));
        var offer = tierOffer(t, prices);
        var full = offer.full;
        var total = Math.max(0, full - offer.saving);
        var p = t.querySelector('[data-ky-price]');
        var c = t.querySelector('[data-ky-compare]');
        var b = t.querySelector('[data-ky-badge]');
        if (p) p.textContent = formatMoney(total);
        var u = t.querySelector('[data-ky-unit-price]');
        if (u) u.textContent = formatMoney(Math.round(total / qty));
        var fv = compareFull ? fullValue(t, qty) : full;
        if (c) { c.textContent = formatMoney(fv); c.hidden = compareFull ? fv <= total : offer.saving <= 0; }
        if (b && b.dataset.template) {
          var pct = full > 0 ? Math.floor(offer.saving * 100 / full) : 0;
          if (compareFull) pct = fv > total ? Math.round((fv - total) * 100 / fv) : 0;
          b.textContent = b.dataset.template
            .replace('[risparmio]', moneyShort(Math.round(offer.saving / 100) * 100))
            .replace('[percentuale]', String(pct))
            .replace('[gratis]', String(offer.freeQty));
          b.hidden = offer.saving <= 0;
        }
        var buyTotal = total;
        var u = upsellOf(t);
        if (u) {
          var uq = Number(u.dataset.qty) || (qty + 1);
          var uPrices = [];
          for (var k = 0; k < uq; k++) uPrices.push(rowPrice(k));
          var uOffer = tierOffer({ dataset: { offerType: 'unit', offerValue: u.dataset.offerValue } }, uPrices);
          var uTotal = Math.max(0, uOffer.full - uOffer.saving);
          var uPrice = Math.max(0, uTotal - total);
          var uFull = uPrices[uq - 1];
          var up = u.querySelector('[data-ky-upsell-price]');
          var uc = u.querySelector('[data-ky-upsell-compare]');
          var ut = u.querySelector('[data-ky-upsell-text]');
          if (up) up.textContent = formatMoney(uPrice);
          if (uc) uc.textContent = formatMoney(uFull);
          if (ut && ut.dataset.template) {
            var upct = uFull > 0 ? Math.round((uFull - uPrice) * 100 / uFull) : 0;
            ut.textContent = ut.dataset.template.replace('[numero]', String(uq)).replace('[percentuale]', String(upct));
          }
          if (upsellOn(t)) buyTotal = uTotal;
        }
        // Riga regalo (modalita' per paio): segue le paia comprate, anche con
        // la casella "paio in piu'" attiva.
        var gn = t.querySelector('[data-ky-gift-name]');
        if (gn && gn.dataset.perPair === 'true') {
          var gq = buyQty(t);
          gn.textContent = (gq > 1 ? gq + 'x Paia di ' : '') + (gn.dataset.text || '');
          var gp = t.querySelector('[data-ky-gift-price]');
          if (gp && gp.dataset.unit) gp.textContent = formatMoney(Number(gp.dataset.unit) * gq);
          var rb = t.querySelector('[data-ky-ribbon]');
          if (rb && rb.dataset.template) rb.textContent = rb.dataset.template.replace('[calzini]', String(gq));
        }
        var s = t.querySelector('[data-ky-ship]');
        if (s) s.hidden = total < (Number(root.dataset.shipThreshold) || 5000);
        if (t.classList.contains('is-selected') && atc) {
          var price = atc.querySelector('[data-ky-atc-price]');
          if (price) price.textContent = formatMoney(buyTotal + (addonOn() ? addonPrice().price : 0));
        }
      });
      updateAtcState();
    }

    function updateAtcState() {
      if (!atc) return;
      var t = selectedTier();
      var qty = buyQty(t);
      var ok = true;
      for (var i = 0; i < qty; i++) {
        var r = rows[i];
        if (sizePos && !r.size) continue; // taglia da scegliere: il click mostra il messaggio
        // senza opzione taglia findVariant cerca solo per colore: cercare con
        // r.size (null) lasciava il bottone disattivato sui prodotti a una sola opzione
        var v = findVariant(r.color, r.size);
        if (!v || !v.available) ok = false;
      }
      var label = atc.querySelector('[data-ky-atc-label]');
      atc.disabled = !ok;
      if (label) label.textContent = ok ? root.dataset.atcText : root.dataset.soldoutText;
    }

    function syncNativeColor(color) {
      if (!colorPos || !color) return;
      var nameEl = root.querySelector('[data-ky-color-name]');
      if (nameEl) nameEl.textContent = color;
      root.querySelectorAll('.ky-swatch').forEach(function (s) { s.classList.toggle('is-active', s.dataset.kySwatch === color); });
      var inputs = section.querySelectorAll('input[type="radio"][name="option' + colorPos + '"]');
      Array.prototype.some.call(inputs, function (input) {
        if (input.value === color) {
          if (!input.checked) { input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); }
          return true;
        }
        return false;
      });
      var select = section.querySelector('select[name="option' + colorPos + '"]');
      if (select && select.value !== color) { select.value = color; select.dispatchEvent(new Event('change', { bubbles: true })); }
    }

    function selectTier(t) {
      tiers.forEach(function (x) {
        var on = x === t;
        x.classList.toggle('is-selected', on);
        var input = x.querySelector('input[type="radio"]');
        if (input) input.checked = on;
      });
      renderPairs();
      updatePrices();
      hideError();
    }

    function showError(msg) { if (errorEl) { errorEl.textContent = msg; errorEl.hidden = false; } }
    function hideError() { if (errorEl) errorEl.hidden = true; }

    tiers.forEach(function (t) {
      t.addEventListener('click', function (e) {
        if (e.target.closest('select')) return;
        if (!t.classList.contains('is-selected')) selectTier(t);
      });
    });

    root.addEventListener('change', function (e) {
      if (e.target.matches && e.target.matches('[data-ky-upsell-check]')) {
        updatePrices();
        hideError();
        return;
      }
      if (addon && (e.target === addonCheck || e.target === addonSelect)) {
        if (e.target === addonSelect) addonTouched = true;
        updatePrices();
        hideError();
        return;
      }
      var sel = e.target.closest('select[data-ky-row]');
      if (!sel) return;
      var i = Number(sel.dataset.kyRow);
      var field = sel.dataset.kyField;
      rows[i][field] = sel.value;
      if (field === 'color') {
        var v = rows[i].size ? findVariant(rows[i].color, rows[i].size) : null;
        if (!requireSize && (!v || !v.available)) rows[i].size = firstAvailableSize(rows[i].color);
        if (i === 0) syncNativeColor(rows[i].color);
        renderPairs();
      }
      updatePrices();
      hideError();
    });

    root.querySelectorAll('[data-ky-swatch]').forEach(function (sw) {
      sw.addEventListener('click', function () {
        var color = sw.dataset.kySwatch;
        rows.forEach(function (r) {
          r.color = color;
          var v = r.size ? findVariant(color, r.size) : null;
          if (!requireSize && (!v || !v.available)) r.size = firstAvailableSize(color);
        });
        syncNativeColor(color);
        renderPairs();
        updatePrices();
      });
    });

    if (atc) {
      atc.addEventListener('click', function () {
        var t = selectedTier();
        var qty = buyQty(t);
        var tierIndex = t.dataset.kyTier;
        var lines = {};
        for (var i = 0; i < qty; i++) {
          var r = rows[i];
          if (sizePos && !r.size) {
            showError(root.dataset.chooseSizeText || 'Seleziona la taglia');
            var bad = t.querySelector('select[data-ky-row="' + i + '"][data-ky-field="size"]');
            if (bad) bad.focus();
            return;
          }
          var v = findVariant(r.color, r.size);
          if (!v || !v.available) { showError(root.dataset.soldoutText); return; }
          lines[v.id] = (lines[v.id] || 0) + 1;
        }
        var items = Object.keys(lines).map(function (id) {
          return { id: Number(id), quantity: lines[id] };
        });
        if (addonOn()) items.push({ id: addonVariantId(), quantity: 1 });

        var labelEl = atc.querySelector('[data-ky-atc-label]');
        var prevLabel = labelEl ? labelEl.textContent : '';
        atc.disabled = true;
        atc.classList.add('is-loading');
        if (labelEl && root.dataset.addingText) labelEl.textContent = root.dataset.addingText;

        // Prima le paia (senza regali), poi il motore regali sul carrello
        // intero: le paia di tutti i modelli contano insieme.
        jsonFetch('/cart/add.js', {
          method: 'POST',
          headers: { [SYNC_HEADER]: '1' },
          body: JSON.stringify({ items: items, sections: ['mini-cart'], sections_url: window.location.pathname })
        })
          .then(function (added) {
            var sections = added.sections;
            return syncGifts().then(function (changed) {
              if (!changed) return sections;
              // i regali sono cambiati dopo l'aggiunta: il mini-cart va riletto
              return fetch(window.location.pathname + '?sections=mini-cart', { headers: { [SYNC_HEADER]: '1' } })
                .then(function (r) { return r.ok ? r.json() : sections; })
                .catch(function () { return sections; });
            });
          })
          .then(function (sections) {
            return jsonFetch('/cart.js', { method: 'GET', headers: { [SYNC_HEADER]: '1' } }).then(function (cart) {
              var detail = Object.assign({}, cart, { sections: sections });
              emit('variant:added', { items: items, cart: detail }, atc);
              emit('cart:updated', { cart: detail });
              emit('cart:refresh', { cart: detail, openMiniCart: true });
            });
          })
          .catch(function (err) { showError(err.message || 'Si è verificato un errore. Riprova.'); })
          .finally(function () {
            atc.classList.remove('is-loading');
            if (labelEl) labelEl.textContent = prevLabel;
            updateAtcState();
          });
      });
    }

    renderPairs();
    updatePrices();
  }

  /* ---------- Regalo automatico (calzini + borsa) ---------- */
  // Regola unica per tutto il negozio (scaglioni, Mix & Match, carrello):
  // - si contano insieme le paia di TUTTE le calzature in KyleaGift.productIds,
  //   escluse le righe regalo (property _ky_gift);
  // - calzini: da minQty paia in su, 1 paio per ogni paio (mode 'per_pair')
  //   oppure sempre KyleaGift.qty (mode 'fixed');
  // - borsa: 1 da bagMinQty paia in su (bagMinQty 0 = nessuna borsa);
  // - nel carrello resta al massimo UNA riga calzini regalo e UNA riga borsa
  //   regalo; ogni altra riga _ky_gift e le varianti regalo aggiunte senza
  //   _ky_gift vanno a 0.
  var GIFT_TAG = 'auto';
  function giftConfig() {
    var c = window.KyleaGift;
    if (!c || !c.enabled || !c.variantId) return null;
    return c;
  }
  function isGiftLine(item) {
    return !!(item && item.properties && item.properties._ky_gift);
  }
  function giftPlan(pairs) {
    var gift = giftConfig();
    var plan = { socks: 0, bag: 0 };
    if (!gift) return plan;
    pairs = Math.max(0, Math.floor(Number(pairs) || 0));
    var minQty = Math.max(1, Number(gift.minQty) || 3);
    if (pairs >= minQty) {
      plan.socks = gift.mode === 'fixed' ? Math.max(1, Number(gift.qty) || 1) : pairs;
    }
    var bagMin = Number(gift.bagMinQty) || 0;
    if (gift.bagVariantId && bagMin > 0 && pairs >= bagMin) plan.bag = 1;
    return plan;
  }
  function cartPairs(cart, gift) {
    var ids = (gift.productIds || []).map(Number);
    var pairs = 0;
    (cart.items || []).forEach(function (item) {
      if (isGiftLine(item)) return;
      if (ids.indexOf(Number(item.product_id)) === -1) return;
      pairs += Number(item.quantity) || 0;
    });
    return pairs;
  }
  // Prezzo pieno della riga (centesimi). Serve come sicurezza: una riga della
  // variante regalo senza _ky_gift si toglie solo se costa 0 €. Se nelle
  // impostazioni finisse per errore un prodotto a pagamento (es. i calzini a
  // 5,90€), le righe comprate dal cliente non vengono toccate.
  function linePrice(item) {
    var p = item.original_price != null ? item.original_price : item.price;
    return Number(p) || 0;
  }
  // Calcola cosa cambiare nel carrello: { updates: {key: qty}, add: [items] }.
  function giftOps(cart, gift) {
    var plan = giftPlan(cartPairs(cart, gift));
    var socksId = Number(gift.variantId);
    var bagId = Number(gift.bagVariantId) || 0;
    var updates = {};
    var add = [];
    var socksLines = [];
    var bagLines = [];
    (cart.items || []).forEach(function (item) {
      var vid = Number(item.variant_id);
      var isGiftVariant = vid === socksId || (bagId && vid === bagId);
      if (!isGiftLine(item)) {
        // regalo aggiunto a mano (senza _ky_gift): non deve restare
        if (isGiftVariant && linePrice(item) === 0) updates[item.key] = 0;
        return;
      }
      if (vid === socksId) socksLines.push(item);
      else if (bagId && vid === bagId) bagLines.push(item);
      else updates[item.key] = 0; // _ky_gift su un'altra variante: non e' un regalo valido
    });
    // Una sola riga per regalo: si tiene quella 'auto' se c'e', altrimenti la
    // prima (anche le vecchie righe con _ky_gift = id prodotto); le altre a 0.
    function keepOne(lines, wanted, variantId) {
      var keep = lines.filter(function (l) { return String(l.properties._ky_gift) === GIFT_TAG; })[0] || lines[0] || null;
      lines.forEach(function (l) { if (l !== keep) updates[l.key] = 0; });
      if (!wanted) {
        if (keep) updates[keep.key] = 0;
      } else if (keep) {
        if (Number(keep.quantity) !== wanted) updates[keep.key] = wanted;
      } else {
        add.push({ id: variantId, quantity: wanted, properties: { _ky_gift: GIFT_TAG } });
      }
    }
    keepOne(socksLines, plan.socks, socksId);
    if (bagId) keepOne(bagLines, plan.bag, bagId);
    // Offerta abbinata: al massimo un pezzo per ogni prodotto richiesto nel
    // carrello (es. una fodera scontata per coperta), nessuno se manca.
    var offerIds = (gift.offerVariantIds || []).map(Number);
    if (offerIds.length && gift.offerRequiresId) {
      var allowed = 0;
      (cart.items || []).forEach(function (item) {
        if (Number(item.product_id) === Number(gift.offerRequiresId)) allowed += Number(item.quantity) || 0;
      });
      (cart.items || []).forEach(function (item) {
        if (offerIds.indexOf(Number(item.variant_id)) === -1) return;
        var q = Number(item.quantity) || 0;
        var keepQty = Math.min(q, allowed);
        allowed -= keepQty;
        if (keepQty !== q) updates[item.key] = keepQty;
      });
    }
    return { updates: updates, add: add, plan: plan };
  }

  // Impronta delle righe regalo (e delle varianti regalo) del carrello: serve a
  // dire se un giro ha cambiato davvero qualcosa, non solo se le chiamate sono
  // andate a buon fine (Shopify puo' limitare la quantita', es. giacenza).
  function giftState(cart, gift) {
    var socksId = Number(gift.variantId);
    var bagId = Number(gift.bagVariantId) || 0;
    var offerIds = (gift.offerVariantIds || []).map(Number);
    return (cart.items || []).filter(function (item) {
      var vid = Number(item.variant_id);
      return isGiftLine(item) || vid === socksId || (bagId && vid === bagId) || offerIds.indexOf(vid) !== -1;
    }).map(function (item) {
      return item.key + ':' + item.quantity;
    }).sort().join('|');
  }

  // Esegue un giro di allineamento. Tutte le chiamate hanno X-Ky-Sync, cosi'
  // il wrapper di fetch non rilancia il sync. Non ridisegna il carrello.
  function doGiftSync() {
    var gift = giftConfig();
    if (!gift) return Promise.resolve(false);
    var sync = {};
    sync[SYNC_HEADER] = '1';
    return jsonFetch('/cart.js', { method: 'GET', headers: sync }).then(function (cart) {
      var ops = giftOps(cart, gift);
      var before = giftState(cart, gift);
      var called = false;
      var chain = Promise.resolve();
      if (Object.keys(ops.updates).length) {
        chain = chain.then(function () {
          return jsonFetch('/cart/update.js', { method: 'POST', headers: sync, body: JSON.stringify({ updates: ops.updates }) })
            .then(function () { called = true; })
            .catch(function (e) { console.warn('[Kylea] regalo: aggiornamento righe', e); });
        });
      }
      // Calzini e borsa con chiamate separate: se uno dei due e' esaurito
      // l'altro arriva lo stesso.
      ops.add.forEach(function (line) {
        chain = chain.then(function () {
          return jsonFetch('/cart/add.js', { method: 'POST', headers: sync, body: JSON.stringify({ items: [line] }) })
            .then(function () { called = true; })
            .catch(function (e) { console.warn('[Kylea] regalo: aggiunta', line.id, e); });
        });
      });
      // Cambiato = lo stato dei regali dopo e' diverso da prima (riletto dal
      // carrello), non "la chiamata ha risposto 200".
      return chain.then(function () {
        if (!called) return false;
        return jsonFetch('/cart.js', { method: 'GET', headers: sync }).then(function (after) {
          return giftState(after, gift) !== before;
        }, function () { return true; });
      });
    }).catch(function (e) {
      console.warn('[Kylea] sync regalo', e);
      return false;
    });
  }

  // syncGifts(): Promise<boolean>, true se il carrello e' cambiato. Non va mai
  // in errore. Se un giro e' gia' in corso ne accoda UNO solo dopo, cosi' chi
  // chiama dopo aver aggiunto paia vede sempre il carrello aggiornato.
  var giftRunning = null;
  var giftQueued = null;
  function syncGifts() {
    if (!giftConfig()) return Promise.resolve(false);
    if (giftRunning) {
      if (!giftQueued) {
        giftQueued = giftRunning.then(function (before) {
          giftQueued = null;
          return syncGifts().then(function (after) { return !!before || after; });
        });
      }
      return giftQueued;
    }
    giftRunning = doGiftSync().then(function (changed) {
      giftRunning = null;
      return changed;
    });
    return giftRunning;
  }

  function isCartPage() {
    return !!(window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.pageType === 'cart');
  }
  // Sync + ridisegno del carrello laterale (chiuso) se qualcosa e' cambiato.
  // Sulla pagina /cart la pagina si ricarica: le quantita' nel modulo
  // resterebbero vecchie e al checkout rimetterebbero i regali di prima.
  function syncGift() {
    return syncGifts().then(function (changed) {
      if (!changed) return false;
      if (isCartPage()) {
        // Freno: al massimo una ricarica ogni 10 secondi, cosi' un regalo che
        // Shopify non riesce ad allineare non blocca /cart in un ciclo.
        var last = 0;
        try { last = Number(sessionStorage.getItem('ky_gift_reload')) || 0; } catch (e) {}
        if (Date.now() - last < 10000) return true;
        try { sessionStorage.setItem('ky_gift_reload', String(Date.now())); } catch (e) {}
        window.location.reload();
        return true;
      }
      return refreshCart(false).then(function () { return true; }, function () { return true; });
    });
  }

  var syncTimer = null;
  function scheduleGiftSync(delay) {
    if (!giftConfig()) return;
    clearTimeout(syncTimer);
    syncTimer = setTimeout(syncGift, delay == null ? 350 : delay);
  }

  // Intercetta le modifiche al carrello fatte dal tema (quantità, rimozioni, aggiunte)
  if (window.fetch && !window.fetch.__kyWrapped) {
    var nativeFetch = window.fetch;
    var wrapped = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var headers = (init && init.headers) || {};
      var isSync = headers instanceof Headers ? headers.has(SYNC_HEADER) : !!headers[SYNC_HEADER];
      var p = nativeFetch.apply(this, arguments);
      if (!isSync && /\/cart\/(add|change|update|clear)(\.js)?/.test(url)) {
        p.then(function () { scheduleGiftSync(); }).catch(function () {});
      }
      return p;
    };
    wrapped.__kyWrapped = true;
    window.fetch = wrapped;
  }

  /* ---------- Aggiunta rapida (spesso comprati insieme / upsell carrello) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ky-quick-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return;
    var id = Number(btn.dataset.kyQuickAdd);
    var prev = btn.innerHTML;
    btn.disabled = true;
    btn.classList.add('is-loading');
    jsonFetch('/cart/add.js', { method: 'POST', headers: { [SYNC_HEADER]: '1' }, body: JSON.stringify({ items: [{ id: id, quantity: 1 }], sections: ['mini-cart'], sections_url: window.location.pathname }) })
      .then(function (added) {
        return jsonFetch('/cart.js', { method: 'GET', headers: { [SYNC_HEADER]: '1' } }).then(function (cart) {
          var detail = Object.assign({}, cart, { sections: added.sections });
          emit('variant:added', { items: [{ id: id, quantity: 1 }], cart: detail }, btn);
          emit('cart:updated', { cart: detail });
          emit('cart:refresh', { cart: detail, openMiniCart: !btn.hasAttribute('data-ky-stay') });
          if (btn.dataset.addedText) btn.innerHTML = btn.dataset.addedText;
        });
      })
      .catch(function () {})
      .finally(function () {
        btn.classList.remove('is-loading');
        setTimeout(function () { btn.disabled = false; btn.innerHTML = prev; }, 1600);
        scheduleGiftSync(0);
      });
  });

  /* ---------- Carousel ---------- */
  if (!customElements.get('ky-carousel')) {
    customElements.define('ky-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-ky-track]');
        if (!this.track) return;
        this.prev = this.querySelector(':scope > [data-ky-prev]') || this.querySelector('[data-ky-prev]');
        this.next = this.querySelector(':scope > [data-ky-next]') || this.querySelector('[data-ky-next]');
        this.dots = this.querySelector('[data-ky-dots]');
        this.onScroll = this.update.bind(this);
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll);
        if (this.prev) this.prev.addEventListener('click', () => this.go(-1));
        if (this.next) this.next.addEventListener('click', () => this.go(1));
        requestAnimationFrame(() => { this.buildDots(); this.update(); });
      }
      disconnectedCallback() { window.removeEventListener('resize', this.onScroll); }
      step() {
        var slide = this.track.querySelector('[data-ky-slide]');
        if (!slide) return this.track.clientWidth;
        var gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        var perView = Math.max(1, Math.round(this.track.clientWidth / (slide.offsetWidth + gap)));
        return perView * (slide.offsetWidth + gap);
      }
      pages() { return Math.max(1, Math.ceil((this.track.scrollWidth - 4) / Math.max(1, this.step()))); }
      go(dir) { this.track.scrollBy({ left: dir * this.step(), behavior: 'smooth' }); }
      buildDots() {
        if (!this.dots) return;
        var n = this.pages();
        this.dots.innerHTML = '';
        if (n <= 1) return;
        for (let i = 0; i < n; i++) {
          var b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('aria-label', 'Vai a ' + (i + 1));
          b.addEventListener('click', () => this.track.scrollTo({ left: i * this.step(), behavior: 'smooth' }));
          this.dots.appendChild(b);
        }
      }
      update() {
        var max = this.track.scrollWidth - this.track.clientWidth - 2;
        if (this.prev) this.prev.disabled = this.track.scrollLeft <= 2;
        if (this.next) this.next.disabled = this.track.scrollLeft >= max;
        this.classList.toggle('is-static', max <= 0);
        if (this.dots) {
          if (this.dots.children.length !== this.pages()) this.buildDots();
          var idx = Math.round(this.track.scrollLeft / Math.max(1, this.step()));
          Array.prototype.forEach.call(this.dots.children, function (d, i) { d.classList.toggle('is-active', i === idx); });
        }
      }
    });
  }

  /* ---------- Video ---------- */
  if (!customElements.get('ky-video')) {
    customElements.define('ky-video', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video) return;
        this.addEventListener('click', () => {
          if (this.video.paused) {
            document.querySelectorAll('ky-video video').forEach((v) => { if (v !== this.video) { v.pause(); } });
            this.video.play();
          } else {
            this.video.pause();
          }
        });
        this.video.addEventListener('play', () => this.classList.add('is-playing'));
        this.video.addEventListener('pause', () => this.classList.remove('is-playing'));
      }
    });
  }

  /* ---------- Modali + scroll ---------- */
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-ky-open]');
    if (opener) {
      var modal = document.getElementById(opener.dataset.kyOpen);
      if (modal) { e.preventDefault(); modal.hidden = false; document.documentElement.classList.add('ky-modal-open'); }
      return;
    }
    var closer = e.target.closest('[data-ky-close]');
    if (closer) {
      var m = closer.closest('.ky-modal');
      if (m) { m.hidden = true; document.documentElement.classList.remove('ky-modal-open'); }
      return;
    }
    var smooth = e.target.closest('[data-ky-smooth]');
    if (smooth) {
      var hash = smooth.getAttribute('href');
      var target = hash && hash.charAt(0) === '#' ? document.querySelector(hash) : null;
      if (target) {
        e.preventDefault();
        var y = target.getBoundingClientRect().top + window.pageYOffset - 90;
        window.scrollTo({ top: y, behavior: 'smooth' });
      }
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.ky-modal:not([hidden])').forEach(function (m) { m.hidden = true; });
    document.documentElement.classList.remove('ky-modal-open');
  });

  /* ---------- Avvio ---------- */
  function boot(scope) {
    (scope || document).querySelectorAll('[data-ky-tiers]').forEach(initTiers);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); scheduleGiftSync(800); });
  } else {
    boot(); scheduleGiftSync(800);
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });

  var PROTECTION_ID = 52887223370060;
  function paidCount(cart) {
    var n = 0;
    (cart.items || []).forEach(function (item) {
      if (isGiftLine(item) || Number(item.variant_id) === PROTECTION_ID) return;
      n += Number(item.quantity) || 0;
    });
    return n;
  }
  document.addEventListener('cart:updated', function (e) {
    var cart = e.detail && e.detail.cart;
    if (!cart || !Array.isArray(cart.items)) return;
    var n = paidCount(cart);
    document.querySelectorAll('cart-count').forEach(function (el) { el.textContent = n; });
  });

  window.KyleaWinter = { formatMoney: formatMoney, refreshCart: refreshCart, syncGift: syncGift, syncGifts: syncGifts, giftPlan: giftPlan };
})();

/* Galleria pagina prodotto: frecce sopra la foto (markup in snippets/product-media.liquid).
   Usano il carosello del tema e si spengono alla prima e all'ultima foto visibile. */
(function () {
  function arrowsOf(carousel) {
    var wrap = carousel && carousel.parentElement;
    if (!wrap) return null;
    var prev = wrap.querySelector(':scope > [data-ky-media-step="prev"]');
    var next = wrap.querySelector(':scope > [data-ky-media-step="next"]');
    return prev && next ? { prev: prev, next: next } : null;
  }
  function sync(carousel) {
    var a = arrowsOf(carousel);
    if (!a) return;
    Promise.resolve(carousel.flickityInstance).then(function (f) {
      if (!f) return;
      var last = f.slides.length - 1;
      a.prev.hidden = a.next.hidden = last < 1;
      a.prev.disabled = f.selectedIndex <= 0;
      a.next.disabled = f.selectedIndex >= last;
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-ky-media-step]');
    if (!b || !b.parentElement) return;
    var carousel = b.parentElement.querySelector(':scope > flickity-carousel');
    if (!carousel) return;
    if (b.getAttribute('data-ky-media-step') === 'prev') carousel.previous();
    else carousel.next();
  });
  // Gli eventi del carosello risalgono fino al documento (anche dopo il cambio colore, che lo ricrea)
  ['flickity:ready', 'flickity:slide-changed'].forEach(function (name) {
    document.addEventListener(name, function (e) {
      if (e.target && e.target.tagName === 'FLICKITY-CAROUSEL') sync(e.target);
    });
  });
  function syncAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-ky-media-step="next"]'), function (b) {
      var carousel = b.parentElement && b.parentElement.querySelector(':scope > flickity-carousel');
      if (carousel) sync(carousel);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncAll);
  else syncAll();
})();

/* Guida alle taglie: il pulsante del quiz chiude il pannello della guida
   (il quiz lo apre ky-quiz.js con lo stesso data-ky-quiz-open). */
document.addEventListener('click', function (e) {
  var b = e.target.closest && e.target.closest('[data-ky-guide-quiz]');
  if (!b || !document.getElementById(b.getAttribute('data-ky-quiz-open'))) return;
  var panel = b.closest('drawer-content, popover-content');
  if (panel && 'open' in panel) panel.open = false;
});
